import { articlePath } from './pulseMetadata.js';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

export default function Article({ article, small }) {
  return (
    <Link to={articlePath(article)} className={`pulse-card ${small ? 'pulse-card-small' : 'pulse-card-featured'}`}>
      {article.feature_image && <img src={article.feature_image} alt={article.feature_image_alt || ''} loading="lazy" />}
      <div className="pulse-card-copy">
        <h4>{article.title}</h4>
        {!small && <p>{article.excerpt}</p>}
        <div className="pulse-card-meta">
          <span>{article.authors.map(author => author.name).join(', ')}</span>
          <time dateTime={article.updated_at}>{dayjs(article.updated_at).format(small ? 'ddd MMM Do' : 'ddd MMM Do @ h:mm a')}</time>
        </div>
      </div>
    </Link>
  );
}
